import React from 'react';
import OnBoardingSections from '../../components/ufo/onboarding/Index';  // ✅ Fix import

const OnBoardingPage = () => {
  return (
    <>
      <OnBoardingSections />  {/* ✅ Fix component usage */}
    </>
  );
};

export default OnBoardingPage;